var productionMode = false;

const urlStart = "https://ahmparts-dash.ahm.to";
const urlSSO = "https://sso.ahm.to";


const VUE_APP_GOOGLE_MAPS_API_ID_DOMAIN_DETECTION = "48d5b2e803a56930f03e701b";
const VUE_APP_GOOGLE_MAPS_API_KEY_DOMAIN_DETECTION =
  "AIzaSyC0C5RxE4Gcf0G03_-055Q_yGf0BtCNBvA";

export default {
  productionMode,
  urlStart,
  urlSSO,
  VUE_APP_GOOGLE_MAPS_API_ID_DOMAIN_DETECTION,
  VUE_APP_GOOGLE_MAPS_API_KEY_DOMAIN_DETECTION,
};
